import { render, staticRenderFns } from "./Mix.vue?vue&type=template&id=11453d70&scoped=true&"
import script from "./Mix.vue?vue&type=script&lang=js&"
export * from "./Mix.vue?vue&type=script&lang=js&"
import style0 from "./Mix.vue?vue&type=style&index=0&id=11453d70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11453d70",
  null
  
)

export default component.exports